import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Il service worker rende l'app utilizzabile offline (serve ai capocantieri in cantiere).
//
// Aggiornamenti: senza quanto segue, dopo ogni pubblicazione il service worker nuovo
// restava "in attesa" e gli utenti continuavano a vedere la versione VECCHIA finché non
// chiudevano TUTTE le schede dell'app — potenzialmente per giorni. Il gestore
// SKIP_WAITING esiste già in service-worker.js, ma nessuno gli mandava mai il messaggio.
// Qui glielo mandiamo, e ricarichiamo una sola volta quando prende il controllo.
const eraGiaControllato = Boolean(
  typeof navigator !== 'undefined' && navigator.serviceWorker && navigator.serviceWorker.controller
);
let ricaricatoPerAggiornamento = false;

if (typeof navigator !== 'undefined' && navigator.serviceWorker) {
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    // Alla PRIMA visita il controller passa da assente a presente (clientsClaim):
    // non è un aggiornamento, non va ricaricato niente.
    if (!eraGiaControllato || ricaricatoPerAggiornamento) return;
    ricaricatoPerAggiornamento = true;
    window.location.reload();
  });
}

serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    if (registration.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    }
  },
});